import { FloatingFormItem, InputDecimal } from '@/components/_common';
import { BankAccount } from '@/core/domain/enterprise/BankAccounts/BankAccounts.types';
import {
  BankAccountSettingsFormValues,
  TitleInterestCode,
} from '@/core/domain/enterprise/BankAccountsSettings/BankAccountsSettings.types';
import { Col, Form, FormInstance, Row, Select } from 'antd';

interface Props {
  form: FormInstance<BankAccountSettingsFormValues>;
  bankAccount?: BankAccount;
}

export default function ConfigBankSlipInterestForm({ form }: Props) {
  return (
    <Form form={form} name="bankAccountConfigBullet">
      <Row gutter={[12, 12]}>
        <Col span={24} md={12} lg={6} xxl={4}>
          <FloatingFormItem
            label="Código Juros"
            name={['interest', 'titleInterestCode']}
          >
            <Select
              allowClear
              style={{ width: '100%' }}
              options={[
                {
                  value: TitleInterestCode.valuePerDay,
                  label: 'Valor por dia',
                },
                {
                  value: TitleInterestCode.monthlyRate,
                  label: 'Taxa Mensal',
                },
                {
                  value: TitleInterestCode.exempt,
                  label: 'Isento',
                },
              ]}
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12} lg={6} xxl={4}>
          <FloatingFormItem
            label="Dias Juros após vencimento"
            name={['interest', 'titleInterestDays']}
          >
            <InputDecimal fractions={0} />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12} lg={6} xxl={4}>
          <FloatingFormItem
            label="Valor Juros"
            name={['interest', 'titleInterestValue']}
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
}
